<script>
export default {
	props: {
		showViewAll: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<template>
	<div class="flex items-end justify-between gap-4 mb-8 sm:mb-10">
		<div>
			<p
				class="font-mono-ui text-xs tracking-[0.22em] uppercase text-accent mb-3"
			>
				Selected work
			</p>
			<h2
				class="font-general-light text-3xl sm:text-4xl tracking-tight text-ink"
			>
				Projects
			</h2>
		</div>
		<div class="hidden sm:flex items-center gap-5">
			<!-- Carousel arrows, home only -->
			<slot name="controls" />
			<router-link
				v-if="showViewAll"
				to="/projects"
				class="group flex items-center gap-2 font-mono-ui text-xs tracking-[0.12em] uppercase text-ink-muted hover:text-ink duration-300"
				aria-label="View all projects"
			>
				View all projects
				<span
					class="text-accent transition-transform duration-300 group-hover:translate-x-1"
					>&rarr;</span
				>
			</router-link>
		</div>
	</div>
</template>

<style scoped></style>
